import { render, staticRenderFns } from "./Qrkc.vue?vue&type=template&id=1949cea2&scoped=true"
import script from "./Qrkc.vue?vue&type=script&lang=js"
export * from "./Qrkc.vue?vue&type=script&lang=js"
import style0 from "./Qrkc.vue?vue&type=style&index=0&id=1949cea2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1949cea2",
  null
  
)

export default component.exports